import { usePolicyOutletContext } from "~/pages/shared/policy/hooks/usePolicyOutletContext";
import { PolicyChecksTab } from "~/pages/shared/policy/tabs/PolicyChecksTab";

export function OrganizationPolicyChecksTab() {
  const { scope } = usePolicyOutletContext();
  return (
    <PolicyChecksTab assignedScope={scope} basePath="/organization/policies" />
  );
}
